export default __webpack_public_path__ + "static/media/Portfolio_Photo.df69528f.png";